<template>
  <div class="home">
    <v-container fluid class="py-0">
      <v-row>
        <v-col cols="12" class="pa-0 position-relative" @mouseover="showArrows = true;" @mouseout="showArrows = false">
          <!-- <template v-if="showArrows">
            <div class="arrow-preview cursor-pointer" @click="carouselPromotionalFunction()">
              <v-icon class="arrow-left-icon">mdi-chevron-left</v-icon>
            </div>
          </template>

          <template v-if="showArrows">
            <div class="arrow-next cursor-pointer" @click="carouselPromotionalBanner++">
              <v-icon class="arrow-right-icon">mdi-chevron-right</v-icon>
            </div>
          </template> -->
          <div style="position: absolute; width: 0px; height: 0px;">
            <template v-for="(promotion, pro) in infoHome.promotionalBanner">
              <template v-if="!promotion.value.image.video">
                <img
                  :src="'https://www.artlesscms.actstudio.xyz/storage/uploads/'+promotion.value.image.path"
                  width="100%"
                  :key="'img-aas838'+pro"
                >
              </template>
            </template>
          </div>

          <v-carousel
            v-model="carouselPromotionalBanner"
            v-bind:hide-delimiter-background="true"
            v-bind:hide-delimiters="true"
            v-bind:show-arrows="true"
            :show-arrows-on-hover="true"
            class="carousel-home-"
            height="auto"
            light
          >
            <v-carousel-item
              v-for="(promotion, pro) in infoHome.promotionalBanner"
              v-bind:key="pro"
              v-bind:to="promotion.value.link"
              v-bind:ripple="false"
              @mousemove="detectPositionLeft"
            >
              <template v-if="promotion.value.image.path != null">
                <template v-if="promotion.value.image.video">
                  <video controls muted autoplay width="100%">
                    <source
                      :src="'https://www.artlesscms.actstudio.xyz/storage/uploads/'+promotion.value.image.path"
                      type="video/mp4"
                    />
                  </video>
                </template>
                <template v-else-if="promotion.value.image.video == false">
                  <img
                    :src="'https://www.artlesscms.actstudio.xyz/storage/uploads/'+promotion.value.image.path"
                    width="100%"
                  >
                </template>
              </template>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>

      <v-row class="block-brown" align="center">
        <v-col cols="12">
          <template v-for="(banner, sm) in infoHome.smallBannerBlack">
            <div :key="sm">
              <v-img
                class="d-block mx-auto d-2k-none"
                :src="'https://www.artlesscms.actstudio.xyz/'+banner.value.imageCustom.path"
                width="585"
              ></v-img>
              <v-img
                class="d-none mx-auto d-2k-block d-4k-none"
                :src="'https://www.artlesscms.actstudio.xyz/'+banner.value.imageCustom.path"
                width="760"
              ></v-img>
              <v-img
                class="d-none mx-auto d-4k-block"
                :src="'https://www.artlesscms.actstudio.xyz/'+banner.value.imageCustom.path"
                width="988"
              ></v-img>
            </div>
          </template>
        </v-col>
      </v-row>

      <v-row align="center" class="mt-12" >
        <v-col cols="12" md="4">
          <v-img :src="'https://artlesscms.actstudio.xyz/'+infoHome.commandeFirstImage.path" class="d-block d-sm-none mx-auto d-2k-none" max-width="100%" width="150"></v-img>

          <v-img :src="'https://artlesscms.actstudio.xyz/'+infoHome.commandeFirstImage.path" class="d-none d-sm-block d-md-none mx-auto d-2k-none" max-width="100%" width="250"></v-img>

          <v-img :src="'https://artlesscms.actstudio.xyz/'+infoHome.commandeFirstImage.path" class="d-none d-md-block d-xl-none mx-auto d-2k-none" max-width="100%" width="250"></v-img>

          <v-img :src="'https://artlesscms.actstudio.xyz/'+infoHome.commandeFirstImage.path" class="d-none d-xl-block mx-auto d-2k-none" max-width="100%" width="350"></v-img>

          <v-img :src="'https://artlesscms.actstudio.xyz/'+infoHome.commandeFirstImage.path" class="d-none ml-auto d-2k-block d-4k-none" max-width="100%" width="455"></v-img>

          <v-img :src="'https://artlesscms.actstudio.xyz/'+infoHome.commandeFirstImage.path" class="d-none ml-auto d-4k-block" max-width="100%" width="800"></v-img>
        </v-col>

        <v-col cols="12" md="7">
          <div class="description-artless">
            <div v-html="infoHome.commandeFirstDescription">

            </div>

            <div class="text-right mt-12">
              
              <router-link to="/about" class="not-text-decoration">
                <span class="btn-read-more-new menu-links d-block">
                  <span class="d-block pb-5">READ MORE</span>
                  <div class="animation-line mt-3"></div>
                </span>
              </router-link>
            </div>
          </div>
        </v-col>
      </v-row>


      <v-row class="mt-12">
        <v-col cols="12" class="mt-5">
          <v-img :src="'https://artlesscms.actstudio.xyz/'+infoHome.CSLogo.path" class="logo-cs"></v-img> 
        </v-col>
      </v-row>

      <v-row class="mt-12" v-if="infoHome.fullImage.length > 0">
        <v-col cols="12" class="px-0">
          <div class="owl-carousel-custom" style="position: relative;">

            <carousel :autoplay="false" :nav="false" :items="2" :dots="false" :responsive="{0:{items:1},600:{items:2}}">
                <template v-for="(image,n) in infoHome.fullImage">
                    <img :src="'https://artlesscms.actstudio.xyz/'+image.path" :key="'nnnn'+n">
                </template>


                <template v-if="infoHome.fullImage.length > 2">
                  <template slot="prev" class="ammm">
                      <span class="prev-icon"><v-icon size="36">mdi-chevron-left</v-icon></span>
                  </template>

                  <template slot="next" class="ammm">
                      <span class="next-icon"><v-icon size="36">mdi-chevron-right</v-icon></span>
                  </template>
                </template>
            </carousel>
          </div>

          </v-img>
        </v-col>
      </v-row>

      <v-row class="mt-12" justify="center">
        <v-col cols="12" class="text-center">
          <p
            class="commande-description"
            v-html="infoHome.commandeDescription"
          ></p>

          <div class="padding-btn-read-more">
            <router-link to="/cs" class="not-text-decoration">
              <span class="btn-read-more-new menu-links d-block mx-auto bold" style="font-family: 'GTAmerica'">
                Visit CS
                <div class="animation-line"></div>
              </span>
            </router-link>
          </div>
        </v-col>
      </v-row>

      <v-row class="mt-12">
        <v-col cols="12">
          <img >
          <v-img :src="'https://artlesscms.actstudio.xyz/'+infoHome.logoCustom.path" class="logo-custom"></v-img>
        </v-col>
        <v-col cols="12" class="px-0 position-relative">
          <!-- <template v-if="arrowLeftCustom">
            <div class="arrow-preview cursor-pointer" @click="carouselCustomFunction()">
              <v-icon class="arrow-left-icon">mdi-chevron-left</v-icon>
            </div>
          </template>

          <template v-if="arrowRightCustom">
            <div class="arrow-next cursor-pointer" @click="carouselCustom++">
              <v-icon class="arrow-right-icon">mdi-chevron-right</v-icon>
            </div>
          </template> -->

          <div class="owl-carousel-custom" style="position: relative;">

            <carousel :autoplay="false" :nav="false" :items="2" :dots="false" :responsive="{0:{items:1},600:{items:2}}">
                <template v-for="(image,n) in infoHome.carouselCustom">
                    <img :src="'https://artlesscms.actstudio.xyz/'+image.path" :key="'nnnnaaa'+n">
                </template>


                <template v-if="infoHome.carouselCustom.length > 2">
                  <template slot="prev" class="ammm">
                      <span class="prev-icon"><v-icon size="36">mdi-chevron-left</v-icon></span>
                  </template>

                  <template slot="next" class="ammm">
                      <span class="next-icon"><v-icon size="36">mdi-chevron-right</v-icon></span>
                  </template>
                </template>
            </carousel>
          </div>

          <!-- <v-carousel
            v-model="carouselCustom"
            v-bind:hide-delimiter-background="true"
            v-bind:hide-delimiters="true"
            v-bind:show-arrows="false"
            height="100%"
          >
            <v-carousel-item
              v-for="(custom, cus) in infoHome.customCarousel"
              v-bind:key="cus"
              v-bind:to="custom.value.urlCustom"
              v-bind:ripple="false"
              @mousemove="detectPositionCarouselCustom"
            >
              <v-img :src="'https://www.artlesscms.actstudio.xyz/'+custom.value.imageCustom.path"></v-img>
            </v-carousel-item>
          </v-carousel> -->
        </v-col>

        <v-col cols="12" class="text-center">
          <p class="description-custom pt-12 pb-4" v-html="infoHome.descriptionCustom"></p>
          <!-- <span class="gtAmerica-bold d-block">VISIT CUSTOM</span> -->
          <router-link to="/custom" class="not-text-decoration">
            <span class="btn-read-more-new menu-links d-block mx-auto bold" style="font-family: 'GTAmerica'">
              Visit CUSTOM
              <div class="animation-line"></div>
            </span>
          </router-link>
        </v-col>
      </v-row>

      <v-row class="mt-12">
        <v-col cols="12" class="px-0">
          <template v-for="(image3, img3) in infoHome.imageSingle">
            <a :href="infoHome.allisonLink" :key="'link-'+img3" target="_blank">
              <v-img
                :src="'https://www.artlesscms.actstudio.xyz/'+image3.value.imageCustom.path"
              ></v-img>
            </a>
          </template>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="12">
          <template v-for="(banner, smW) in infoHome.imageBannerWhite">
            <div :key="smW">
              <v-img
                class="d-block d-md-none mx-auto d-2k-none"
                :src="'https://www.artlesscms.actstudio.xyz/'+banner.value.imageCustom.path"
                width="200"
              ></v-img>
              <v-img
                class="d-none d-md-block mx-auto d-2k-none"
                :src="'https://www.artlesscms.actstudio.xyz/'+banner.value.imageCustom.path"
                width="400"
              ></v-img>
              <v-img
                class="d-none mx-auto d-2k-block d-4k-none"
                :src="'https://www.artlesscms.actstudio.xyz/'+banner.value.imageCustom.path"
                width="520"
              ></v-img>
              <v-img
                class="d-none mx-auto d-4k-block"
                :src="'https://www.artlesscms.actstudio.xyz/'+banner.value.imageCustom.path"
                width="676"
              ></v-img>
            </div>
          </template>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
export default {
  name: "Home",
  components: { carousel },
  data() {
    return {
      carouselPromotionalBanner: 0,
      infoHome: [],
      arrowLeft: false,
      arrowRight: false,
      arrowLeftCustom: false,
      arrowRightCustom: false,
      carouselCustom: 0,
      showArrows: false
    };
  },
  mounted() {
    this.$emit("update", 0);

    var breadcrumbs = [
        {
            text: 'Home',
            link: '/',
            isLink: false
        }
    ];
    this.$emit("updateStatus", breadcrumbs);

    gtag('config', 'UA-26953667-1', {
      'page_title' : 'Home',
      'page_path': '/'
    });
  },
  created: function () {
    //fetch singleton home
    fetch(
      "https://www.artlesscms.actstudio.xyz/api/singletons/get/home?token=a15be93e9cdb43ca2b3778c2077c26"
    )
      .then((data) => data.json())
      .then((data) => (this.infoHome = data))
      .catch((error) => console.log(error.message));
  },
  methods: {
    detectPositionLeft: function (event) {
      if (event.screenX > 0 && event.screenX < 960) {
        this.arrowLeft = true;
      } else {
        this.arrowLeft = false;
      }

      if (event.screenX > 960) {
        this.arrowRight = true;
      } else {
        this.arrowRight = false;
      }
    },
    detectPositionCarouselCustom: function (event) {
      if (event.screenX > 0 && event.screenX < 960) {
        this.arrowLeftCustom = true;
      } else {
        this.arrowLeftCustom = false;
      }

      if (event.screenX > 960) {
        this.arrowRightCustom = true;
      } else {
        this.arrowRightCustom = false;
      }
    },
    carouselPromotionalFunction: function () {
      this.carouselPromotionalBanner--;

      if (this.carouselPromotionalBanner < 0) {
        this.carouselPromotionalBanner =
          this.infoHome.promotionalBanner.length - 1;
      }
    },
    carouselCustomFunction: function () {
      this.carouselCustom--;

      if (this.carouselCustom < 0) {
        this.carouselCustom = this.infoHome.customCarousel.length - 1;
      }
    },
    bold: function (htmlText, word) {
      var text = htmlText;
      var wordToFind = word;
      // console.log(text.split(' ').some((w)=>{return w === wordToFind}));

      return text;
    },
  },
};
</script>
